if (!customElements.get("speech-recognition")) {
  class SpeechRecognitionElement extends HTMLElement {
    constructor() {
      super();

      this.recognition = null;
      this.isListening = false;

      this.initRecognition();

      this.addEventListener("click", this.toggleListening.bind(this));

      this.addEventListener("keydown", (event) => {
        if (event.code === "Enter" || event.code === "Space") {
          event.preventDefault();
          this.toggleListening();
        }
      });
    }

    disconnectedCallback() {
      if (this.recognition) {
        this.recognition.stop();
        this.recognition = null;
      }
    }

    toggleListening() {
      if (!this.recognition) {
        this.emitError("Speech recognition is not supported in this browser.");
        return;
      }

      if (this.isListening) {
        this.recognition.stop();
      } else {
        this.recognition.start();
      }
    }

    initRecognition() {
      const Recognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!Recognition) {
        this.classList.add("init-failed");
        return;
      }

      this.recognition = new Recognition();
      this.recognition.interimResults = false;
      this.recognition.continuous = false;

      this.recognition.onresult = this.handleResult.bind(this);
      this.recognition.onaudiostart = this.handleAudioStart.bind(this);
      this.recognition.onaudioend = this.handleAudioEnd.bind(this);
      this.recognition.onend = this.handleEnd.bind(this);
      this.recognition.onerror = this.handleError.bind(this);

      this.classList.add("init-success");
    }

    handleResult(event) {
      const transcript = event.results[0][0].transcript;

      this.dispatchEvent(
        new CustomEvent("speech-result", {
          detail: { transcript },
          bubbles: true,
        })
      );
    }

    handleAudioStart() {
      this.isListening = true;
      this.classList.add("is-listening");
    }

    handleAudioEnd() {
      this.isListening = false;
      this.classList.remove("is-listening");
    }

    handleEnd() {
      this.isListening = false;
      this.classList.remove("is-listening");
    }

    handleError(event) {
      let message = "Speech recognition error.";

      switch (event.error) {
        case "no-speech":
          message = "No speech detected.";
          break;
        case "audio-capture":
          message = "Microphone not available.";
          break;
        case "not-allowed":
          message = "Microphone permission denied.";
          break;
      }

      this.isListening = false;
      this.classList.remove("is-listening");

      if (this.recognition) {
        this.recognition.abort();
      }

      this.emitError(message);
    }

    emitError(message) {
      this.dispatchEvent(
        new CustomEvent("speech-error", {
          detail: { message },
          bubbles: true,
        })
      );
    }
  }

  customElements.define("speech-recognition", SpeechRecognitionElement);
}
